import styled from '~/app/components/styled'
import { Typography } from '@yanolja-rnd/ya-com-core'
import {
  TCommonVipBadgeType,
  CommonVipBadgeType,
} from '~/api/converters/global/common/VipDiscountBadge/index.type'

const Container = styled.div`
  display: flex;
`

const Wrapper = styled.span`
  border-radius: 0.2rem;
  height: 2rem;
  line-height: 1.2rem;
  display: flex;
  flex-basis: fit-content;
  align-items: center;
`

/**
 * [DEFECT-23580]
 * html2canvas 로 이미지 저장시 display: inline-flex 가 동작하지 않음.
 * inline-flex 를 사용하지 않고 display: flex & flex-basis: fit-content 조합을 사용
 */
const BadgeWrapper = styled(Wrapper)`
  padding: 0 0.5rem;
  border: 0.1rem solid ${({ theme }) => theme.color.white_op10};
  background-color: ${({ theme }) => theme.color.black_op80};
  justify-content: space-between;
  padding: 0 0.5rem;
`

const ImageWrapper = styled.span`
  display: flex;
  align-items: flex-start;
  img {
    margin-right: 0.2rem;
  }
`

const Text = styled.span`
  ${Typography('badge').bold};
  color: ${({ theme }) => theme.color.yagold200};
  margin-left: 0.1rem;
  margin-top: -0.1rem;
`

const FlightBadgeWrapper = styled(Wrapper)`
  ${Typography('badge').bold};
  background-color: ${({ theme }) => theme.color.blue600};
  color: ${({ theme }) => theme.color.white};
  padding: 0 0.5rem;
`

type Props = {
  className?: string
  type: TCommonVipBadgeType | ''
}

const MemberClass = ({ type }: { type: TCommonVipBadgeType }) => {
  switch (type) {
    case CommonVipBadgeType.GOLD:
      return (
        <BadgeWrapper>
          <ImageWrapper>
            <img
              src={'https://yaimg.yanolja.com/joy/sunny/static/images/icon_class_gold_symbol.png'}
              width={10}
              height={10}
              alt="Gold Class 로고"
            />
            <img
              src={'https://yaimg.yanolja.com/joy/sunny/static/images/icon_class_gold_text.png'}
              width={24}
              height={10}
              alt="Gold"
            />
          </ImageWrapper>
          <Text>특가</Text>
        </BadgeWrapper>
      )
    case CommonVipBadgeType.FLIGHT:
      return <FlightBadgeWrapper>항공특가</FlightBadgeWrapper>
    default:
      return null
  }
}

/**
 * @summary 회원등급제 뱃지
 * @param {string} className - for styled component override
 * @param {TCommonVipBadgeType | string} type - 회원등급
 */
const VipDiscountBadge = ({ className, type }: Props) => {
  if (type === '') {
    return null
  }

  return (
    <Container className={className}>
      <MemberClass type={type} />
    </Container>
  )
}

export default VipDiscountBadge
